import React from "react";
import { ListItemButton, ListItemIcon, ListItemText, Box, useMediaQuery } from "@mui/material";
import arrow from "../../assets/icons/Arrow.svg";
import { useTheme } from "../../theme/ThemeContext";

interface NavButtonProps {
  text: string;
  icon: any; // Accepting React component
  hasArrow?: boolean;
  isActive: boolean;
  isOpen: boolean;
  onClick: () => void;
  arrowRotated?: boolean;
}

const NavButton: React.FC<NavButtonProps> = ({
  text,
  icon: Icon, // Renamed for clarity
  hasArrow,
  isActive,
  isOpen,
  onClick,
  arrowRotated,
}) => {
  const { theme } = useTheme();

  const sm = useMediaQuery("(max-width:600px)");

  return (
    <ListItemButton
      onClick={onClick}
      sx={{
        borderRadius: "8px",
        padding: sm ? "6px" : "12px", // Responsive padding
        mb: 1,
        marginBottom: "0px",
        transition: "background-color 0.3s ease-in-out, opacity 0.3s ease-in-out",
        opacity: isActive ? 1 : 0.9,
        backgroundColor: isActive
          ? theme.palette.background.paper
          : "transparent",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
      }}
    >
      {/* Icon with theme-aware color */}
      <ListItemIcon
        sx={{
          minWidth: 0,
        
          justifyContent: isOpen ? "flex-start" : "center",
          color: isActive ? theme.palette.text.primary : theme.palette.linkInactive, // Ensure color updates correctly
        }}
      >
        {Icon}
      </ListItemIcon>

      {/* Text */}
      {isOpen && (
        <Box
          sx={{
            opacity: isOpen ? 1 : 0,
            transform: isOpen ? "translateX(0)" : "translateX(-10px)",
            transition: "opacity 0.5s ease-in-out, transform 0.5s ease-in-out",
          }}
        >
          <ListItemText
            primary={text}
            sx={{
              color: isActive ? theme.palette.text.primary : theme.palette.linkInactive, // Ensure color updates correctly
              fontWeight: 600,
              fontSize: "16px",
            }}
          />
        </Box>
      )}

      {/* Arrow Icon */}
      {hasArrow && isOpen && (
        <img src={arrow} alt="arrow" className="w-[24px] h-[24px] ml-auto"
          style={{
            transform: arrowRotated ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s ease-in-out",
          }}
        />
      )}
    </ListItemButton>
  );
};

export default NavButton;
